import ArtworksPage from "./ArtworksPage"

export default ArtworksPage